module.exports = __webpack_public_path__ + "static/cad-designs21-8e4e02d3ab012118458532187982afd2.png";